import { render } from "./ProductionTracking.vue?vue&type=template&id=691741b0&scoped=true&ts=true&lang=pug"
import script from "./ProductionTracking.vue?vue&type=script&lang=ts"
export * from "./ProductionTracking.vue?vue&type=script&lang=ts"

import "./ProductionTracking.vue?vue&type=style&index=0&id=691741b0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691741b0"]])

export default __exports__